import { useQuery } from "@tanstack/react-query";
import { getAllIndustries } from "../../api/companies";

const useIndustries = () => {
  // ############
  // GET QUERIES
  // ############

  // getAllIndustries query
  const { data: allIndustriesData } = useQuery({
    queryKey: ["industries"],
    queryFn: getAllIndustries,
  });
  const allIndustries = allIndustriesData ? allIndustriesData.data : [];

  return { allIndustries };
};

export default useIndustries;
